export default {
    skips: [
        { name: "Aguardando", value: "WAIT"},
        { name: "Já notificados hoje", value: "SKIP_RECENTLY_NOTIFIED"},
        { name: "Campanha de exclusividade", value: "SKIP_EXCLUSIVITY_CAMPAIGN"},
        { name: "Possuem inconsistência na mensagem", value: "SKIP_INCONSISTENT_VAR"},
        { name: "Cliente com proposta já confirmada", value: "SKIP_PROPOSAL_CONFIRMED"},
        { name: "Constam na blacklist", value: "SKIP_BLACKLIST"},
        { name: "Multicredor", value: "SKIP_MULTICREDITOR"},
        { name: "Orçamento excedido",value: "SKIP_BUDGET_REACHED"},
        { name: "Final de abordagem",value: "SKIP_END_OF_APPROACH"},
        { name: "SKIP_NOT_APPROACH_CALLCELLPHONE",value: "SKIP_NOT_APPROACH_CALLCELLPHONE"},
        { name: "SKIP_NOT_APPROACH_EMAIL",value: "SKIP_NOT_APPROACH_EMAIL"},
        { name: "Notificado nos últimos dias",value: "SKIP_RECENTLY_WHATSAPP_NOTIFIED"},
        { name: "Início de abordagem",value: "SKIP_OUT_OF_APPROACH"},
        { name: "SKIP_NOT_APPROACH_SMS",value: "SKIP_NOT_APPROACH_SMS"},
        { name: "SKIP_NOT_APPROACH_PUSH",value: "SKIP_NOT_APPROACH_PUSH"},
        { name: "Domínio Gmail",value: "SKIP_GMAIL_DOMAIN"},
        { name: "Contato duplicado",value: "SKIP_PREPARE_DUPLICATED"},
        { name: "Final da abordagem PUSH",value: "SKIP_END_OF_APPROACH_PUSH"},
        { name: "Final da abordagem SMS",value: "SKIP_END_OF_APPROACH_SMS"},
        { name: "Início de abordagem SMS",value: "SKIP_OUT_OF_APPROACH_SMS"},
        { name: "Início da abordagem PUSH", value: "SKIP_OUT_OF_APPROACH_PUSH"},
        { name: "Final da abordagem CALL CELLPHONE",value: "SKIP_END_OF_APPROACH_CALL_CELLPHONE"},
        { name: "Final da abordagem EMAIL", value: "SKIP_END_OF_APPROACH_EMAIL"},
        { name: "Final da abordagem WHATSAPP", value: "SKIP_END_OF_APPROACH_WHATSAPP"},
        { name: "Final da abordagem PUSH", value: "SKIP_END_OF_APPROACH_PUSH"},
        { name: "SKIP_NOT_APPROACH_CALL_CELLPHONE",value: "SKIP_NOT_APPROACH_CALL_CELLPHONE"},
        { name: "SKIP_EMAIL_NEW_LIMIT",value: "SKIP_EMAIL_NEW_LIMIT"},
        { name: "Início de abordagem CALL CELLPHONE",value: "SKIP_OUT_OF_APPROACH_CALL_CELLPHONE"},
        { name: "Início de abordagem EMAIL",value: "SKIP_OUT_OF_APPROACH_EMAIL"},
        { name: "Variável inconsistente no asset",value: "SKIP_INCONSISTENT_VAR_ASSET"},
        { name: "Orçamento credor excedido", value: "SKIP_CREDITOR_BUDGET_REACHED"},
        { name: "Orçamento estímulo excedido", value: "SKIP_STIMULUS_BUDGET_REACHED"},
        { name: "Orçamento estímulo SMS excedido", value: "SKIP_APPROACH_SMS_BUDGET_REACHED"},
        { name: "Orçamento estímulo WHATSAPP excedido", value: "SKIP_APPROACH_WHATSAPP_BUDGET_REACHED"},
        { name: "Orçamento estímulo EMAIL excedido", value: "SKIP_APPROACH_EMAIL_BUDGET_REACHED"},
        { name: "Árvore com retroativo desativado",value: "SKIP_DEBT_BASE_DEACTIVATED"},
        { name: "SKIP_EMAIL_NOTIFY_COUNT_ALL",value: "SKIP_EMAIL_NOTIFY_COUNT_ALL"},
        { name: "Cliente logado recentemente", value: "SKIP_CUSTOMER_LOGADO"},
        { name: "Quarentena de desinteresse", value: "SKIP_NOTIFICADO_LOCALIZADO"},
        { name: "Notificações não processadas até o momento", value: "missing"},
        { name: "Não notificados pela regra de rotação de credor (1 dia)", value: "SKIP_ROTATE_MULTICREDITOR_1"},
        { name: "Não notificados pela regra de rotação de credor (2 dias)", value: "SKIP_ROTATE_MULTICREDITOR_2"},
        { name: "Não notificados pela regra de rotação de credor (3 dias)", value: "SKIP_ROTATE_MULTICREDITOR_3"},
        { name: "Não notificados pela regra de rotação de credor (4 dias)", value: "SKIP_ROTATE_MULTICREDITOR_4"},
        { name: "Não notificados pela regra de rotação de credor (5 ou mais dias)", value: "SKIP_ROTATE_MULTICREDITOR_5_PLUS"},
        { name: "Domínio em aquecimento atingiu o limite de envio diário", value:"SKIP_EMAIL_DOMAIN_LIMIT" },
        { name: "Contato de email já enviado para domínio em aquecimento", value:"SKIP_EMAIL_DOMAIN_WARMUP"},
    ],
};